var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 19.0004C6.15833 19.0004 5.771 18.8464 5.463 18.5384C5.15433 18.2297 5 17.8421 5 17.3754V15.0004H6V17.3754C6 17.5421 6.06267 17.6877 6.188 17.8124C6.31267 17.9377 6.45833 18.0004 6.625 18.0004H17.375C17.5417 18.0004 17.6873 17.9377 17.812 17.8124C17.9373 17.6877 18 17.5421 18 17.3754V15.0004H19V17.3754C19 17.8421 18.846 18.2297 18.538 18.5384C18.2293 18.8464 17.8417 19.0004 17.375 19.0004H6.625ZM12 15.2254L8.45 11.7004L9.175 10.9754L11.5 13.3004V4.65039H12.5V13.3004L14.825 10.9754L15.55 11.7004L12 15.2254Z",
    fill: "#15B79E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.73b4594204c8e6ec7f3a45a4c0138b1d.svg";
export { ForwardRef as ReactComponent };